import {ActionWithPayload} from "../../redux/createAction";
import {SET_PARTICIPANTS} from "./participantsConstants";

const initialState = {
    participants : [],
};


export default function participantsReducer(state = initialState, action: ActionWithPayload<any>) {
    switch (action.type) {
        case SET_PARTICIPANTS: {
            return {...state, participants : action.payload.participants};
        }
        default:
            return state;
    }
}

